import { render, staticRenderFns } from "./MoleculeBuildingFloorLabel.vue?vue&type=template&id=6bee2dd8&scoped=true&"
import script from "./MoleculeBuildingFloorLabel.vue?vue&type=script&lang=js&"
export * from "./MoleculeBuildingFloorLabel.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeBuildingFloorLabel.vue?vue&type=style&index=0&id=6bee2dd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee2dd8",
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeBuildingFloorLabel.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FbuildingV2%2FMoleculeBuildingFloorLabel.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsAtomLoader: require('/app/components/atoms/AtomLoader.vue').default,MoleculesProjectBuildingV2MoleculeAvailabilitySpaceFilterResultBuilding: require('/app/components/molecules/project/buildingV2/MoleculeAvailabilitySpaceFilterResultBuilding.vue').default})
